module.exports = __webpack_public_path__ + "img/588x310-04.17c2c34c.png";